import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { withRouter } from 'react-router';
import cx from 'classnames';

import { isGreaterThanMobile } from '@selectors/browser';

import LoginMenu from '../LoginMenu/LoginMenu';
import SideMenu from '../SideMenu/SideMenu';

import './TopBar.scss';

const TopBar = ({
  isMobile,
  location: { pathname },
}) => (
  <div className="top-bar">
    <div className="top-bar__logo-wrapper">
      <RouterLink to="/">
        <img
          src="/images/logo.png"
          className="top-bar__logo"
          alt="logo"
        />
      </RouterLink>
    </div>
    {!isMobile && (
      <div className="top-bar__links">
        <RouterLink
          to="/cases"
          className={cx('top-bar__link', { 'top-bar__link--active': pathname === '/cases' })}
        >
          Cases
        </RouterLink>
        <RouterLink
          to="/contact"
          className={cx('top-bar__link', { 'top-bar__link--active': pathname === '/contact' })}
        >
          Contact
        </RouterLink>
        <LoginMenu />
      </div>
    )}
    {isMobile && (
      <SideMenu />
    )}
  </div>
);

TopBar.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  isMobile: !isGreaterThanMobile(state),
});

export default withRouter(connect(mapStateToProps)(TopBar));



// WEBPACK FOOTER //
// ./src/routes/containers/TopBar/TopBar.js